// Webpack Imports
import * as bootstrap from 'bootstrap';
import './swipers/index';
import { initGLightbox } from './lightbox-init';
import { initInnerImageZoom } from './inner-image-zoom-init';
import './back-to-top';

import './animate';
import './menu-hover-desktop';
import './menu-toggle-mobile';

initGLightbox();
initInnerImageZoom();

(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach(function (popoverTriggerEl) {
        new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus'
        });
    });
})();
